import $ from 'jquery';
import jQuery from 'jquery';
window.$ = jQuery;
import AOS from 'aos';
import 'bootstrap';
import 'jquery-parallax.js';
import Blazy from 'blazy';
import owlCarousel from 'owl.carousel';
import lightGallery from 'lightgallery';
import Inputmask from "inputmask";
import 'lg-video';
// import 'lg-zoom';
import 'select2';
import Sticky from "sticky-js";
// var sticky = new Sticky('.sticky-box');

//Fashion studio deps.
import slick from 'slick-carousel';
import Swiper from 'swiper/bundle';
import Lazy from 'jquery-lazy';
import 'jquery-lazy/plugins/jquery.lazy.av.js';
import 'jquery-lazy/plugins/jquery.lazy.iframe.js';

(function($){

    // variable used to check if width has changed
    // fix issue on mobile with sticky browser bar
    var lastWidth = $(window).width();

    //Prevents loading iframe with viewer, instead of loading first gallery on init by Swiper
    var instance = $('.lazy, .lazy-video').Lazy({
        chainable: false,
        visibleOnly: true
    });
    
    //Prevent displaying OrbitvuViewer in Lightgallery
    $('.swiper-viewer-container[data-iframe="true"]').each(function(index, element){
        const windowWidth = window.innerWidth;

        if (windowWidth > 768) {
            $(element).removeClass('lgitem');
        }
    });

    $('.lightgallery').each(function(index, element){
        $(this).lightGallery({
            // selector, prevents add orbitvuviewer to lightgallery
            selector: '.lgitem',
            galleryId: index + 1,
            download: false,
            share: false,
            fullScreen: false,
            autoplayControls: false,
            thumbnail: false
        });
        
        $(this).on('onAfterSlide.lg',function(event, index, fromTouch, fromThumb){
            const isVideoOrIframe = $('.lg-current .lg-has-iframe').length || $('.lg-current .lg-has-html5').length;

            if(isVideoOrIframe) {
                $(".lg-toolbar").addClass('iframe-lg-toolbar');            
            } else {
                $(".lg-toolbar").removeClass('iframe-lg-toolbar');
            }
        });
    });

    $(document).ready(function(){
        $('.slider').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 1500,
            arrows: false,
            dots: false,
            lazy: true,
            pauseOnHover: false,
            responsive: [{
                breakpoint: 768,
                settings: {
                    slidesToShow: 4
                }
            }, {
                breakpoint: 520,
                settings: {
                    slidesToShow: 3
                }
            }]
        });
    });

    const overlayVideo = $('.video1')[0];

    $(function() {
        $('.scroll-down-b').click (function() {
            $('html, body').animate({scrollTop: $('div.benefits').offset().top }, 'slow');
            overlayVideo.pause();
            return false;
        });

        $('.book-demo').click(function () {
            $('.widget-form').show();
        });

        const caseStudyVideo = function() {
            const video = '<iframe width="100%" height="303" frameborder="0" src="' + $(this).parents('.video-container').attr('data-video') + '&autoplay=1" allowfullscreen></iframe>';
            $(this).parents('.video-container').replaceWith(video);
        };

        $('.js-videoPoster').click(caseStudyVideo);
        $('.external-button').click(caseStudyVideo);


    });

    var isPLaying = false;

    $(document).ready(function() {
        $('.workflow-creative').on('click', function() {
            $(this).lightGallery({
                galleryId: 32,
                dynamic: true,
                download: false,
                share: false,
                fullScreen: false,
                autoplayControls: false,
                zoom: false,
                thumbnail: false,
                counter: false,
                videoMaxWidth: '1170px',
                videoAutoplay: true,
                youtubePlayerParams: yt_parametrs,
                dynamicEl: [
                    {
                        src: $(this).data('yt-url'),
                        poster: $(this).data('poster-url')                        
                    }
                ]
            });
        });

        $('.workflow-creative').on('onBeforeOpen.lg',function(event){
            overlayVideo.pause();
            isPLaying = true;
        });

        $('.workflow-creative').on('onCloseAfter.lg',function(event){
            overlayVideo.pause();
            isPLaying = false;
        });

        $('.workflow-gallery').on('click', function() {
            $(this).lightGallery({
                galleryId: 31,
                dynamic: true,
                download: false,
                share: false,
                fullScreen: false,
                autoplayControls: false,
                zoom: false,
                thumbnail: false,
                counter: false,
                videoMaxWidth: '1170px',
                videoAutoplay: true,
                youtubePlayerParams: yt_parametrs,
                dynamicEl: [
                    {
                        src: $(this).data('yt-url'),
                        poster: $(this).data('poster-url')                        
                    }
                ]
            });
        });

        $('.workflow-gallery').on('onBeforeOpen.lg',function(event){
            overlayVideo.pause();
            isPLaying = true;
        });

        $('.workflow-gallery').on('onCloseAfter.lg',function(event){
            overlayVideo.pause();
            isPLaying = false;
        });

        if($('#hero-yt-video').length > 0) {

            var ytHeroVideoObj = [ 
                {
                    src: 'https://www.youtube.com/embed/'+$('#hero-yt-video').data('hero-yt-video'),
                    poster: $('#hero-yt-video').data('hero-yt-poster')
                }
            ];

            $('#button').on('click', function() {
                $(this).lightGallery({
                    galleryId: 30,
                    dynamic: true,
                    download: false,
                    share: false,
                    fullScreen: false,
                    autoplayControls: false,
                    zoom: false,
                    thumbnail: false,
                    counter: false
        ,            videoMaxWidth: '1170px',
                    videoAutoplay: true,
                    dynamicEl: ytHeroVideoObj
                });
            });

            $('#button').on('onBeforeOpen.lg',function(event){
                overlayVideo.pause();
                isPLaying = true;
            });

            $('#button').on('onCloseAfter.lg',function(event){
                overlayVideo.play();
                isPLaying = false;
            });
        }

    });

    function isScrolledIntoView(elem)
    {
        if(elem === undefined || elem === null)
            return false;

        var docViewTop = $(window).scrollTop();
        var docViewBottom = docViewTop + $(window).height();

        var elemTop = $(elem).offset().top;
        var elemBottom = elemTop + $(elem).height();
        return ((elemBottom <= docViewBottom + $(elem).height()/2 + 30) && (elemTop + $(elem).height()/2 + 30 >= docViewTop));
    }

    const firstVideoGallery = $('.video-gallery')[0];
    let orbittourInjected = 0;
    $(window).scroll(function(){
        if (!isPLaying) {
            if ($('.cover').length) {
                isScrolledIntoView('.cover') ? overlayVideo.play() : overlayVideo.pause();
            }
        } else {
            overlayVideo.pause();
        }
        if( firstVideoGallery !== undefined ) {
            if ($('.gallery-white').length) {
                isScrolledIntoView('.gallery-white') ? firstVideoGallery.play() : firstVideoGallery.pause();
            }
        }
        // if (!orbittourInjected && isScrolledIntoView('#orbittour-BQGVkbgPwMMWJSeXKkjmb5')) {
        //     inject_orbittour_BQGVkbgPwMMWJSeXKkjmb5();
        //     orbittourInjected = 1;
        // }
    })

    window.onload = function() {
        const videos = document.querySelectorAll(".video");
        videos.forEach((video , index) => {
            const play = document.querySelectorAll(".playpause")[index];
            play.addEventListener("mouseover", function () {
                video.play();
                play.classList.add('d-none');
            })

            play.addEventListener("touchend", function () {
                video.play();
                play.classList.add('d-none');
                return false;
            })

            video.addEventListener("mouseover", function () {
                this.play()
                play.classList.add('d-none');
            })

            video.addEventListener("mouseout", function () {
                this.pause()
                play.classList.remove('d-none');
            })

            video.addEventListener("touchend", function () {
                if (this.paused) {
                    this.play();

                    play.classList.add('d-none');
                } else {
                    this.pause();
                    play.classList.remove('d-none');
                }

                return false;

            })
        })
    }

    function isMobile() {
        try{ document.createEvent("TouchEvent"); return true; }
        catch(e){ return false; }
    }

    var lastIndex = 0;
    var currentIndex = 0;
    var indexCreativity = 0;
    
    // create gallerytop swiper
    const galleryTopSwipers = [];

    // create thumbs swiper
    if ( document.getElementsByClassName('gallery-new-thumbs').length ) {

        const galleryThumbs = new Swiper('.gallery-new-thumbs', {
            slidesPerView: 4,
            freeMode: false,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            updateOnWindowResize: true,
            observeParents: true,
            observeSlideChildren: true,

        });
        let galleryTopIndex = 0;

        galleryThumbs.map((item, i) => {
            const galleryTop = new Swiper(".gallery-" + (i+1), {
                nested: true,
                mousewheel: true,
                effect: 'fade',
                updateOnWindowResize: true,
                observeParents: true,
                observeSlideChildren: true,
                thumbs: {
                    swiper: /*isMobile() ? mobileThumbs : */galleryThumbs[i],
                    autoScrollOffset: 2
                },
                preloadImages: false,
                lazy: true
            });
            galleryTopSwipers.push(galleryTop);
        });
    }

    // create gallerytop swiper
    const galleryBikeTopSwipers = [];

    // create thumbs swiper bike gallery
    if ( document.getElementsByClassName('gallery-new-thumbs-bike').length ) {

        const galleryBikeThumbs = new Swiper('.gallery-new-thumbs-bike', {
            // slidesPerView: 2,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            updateOnWindowResize: true,
            observeParents: true,
            observeSlideChildren: true,
            lazy: {
                checkInView: true
            },
            preloadImages: false,
            // centerInsufficientSlides: true,
            navigation: {
                nextEl: '.swiper-bike-child-next',
                prevEl: '.swiper-bike-child-prev'
            },
            breakpoints: {
                // when window width is >= 320px
                320: {
                  slidesPerView: 4,
                  spaceBetween: 5
                },
                // when window width is >= 480px
                480: {
                  slidesPerView: 4,
                  spaceBetween: 10
                },
                // when window width is >= 768px
                481: {
                  slidesPerView: 6,
                  spaceBetween: 10
                },
                // when window width is >= 1280px
                1200: {
                  slidesPerView: 'auto',
                  spaceBetween: 15,
                  loopedSlides: 4
                }
            }
        });

        let galleryTopIndex = 0;

        galleryBikeThumbs.map((item, i) => {

            const galleryBikeTop = new Swiper(".gallery-bike-" + (i+1), {
                nested: true,
                mousewheel: false,
                keyboard: {
                    enabled: false
                },
                effect: 'fade',
                updateOnWindowResize: true,
                observeParents: true,
                observeSlideChildren: true,
                allowTouchMove: false,
                thumbs: {
                    swiper: /*isMobile() ? mobileThumbs : */galleryBikeThumbs[i]
                },
                navigation: {
                    // nextEl: '.swiper-bike-child-next',
                    // prevEl: '.swiper-bike-child-prev'
                    nextEl: '.swiper-bike-child-next-' + (i + 1),
                    prevEl: '.swiper-bike-child-prev-' + (i + 1)
                },
                preloadImages: false,
                lazy: {
                    checkInView: true
                },
            });

            galleryBikeTopSwipers.push(galleryBikeTop);

            // item.parent().find('.swiper-bike-child-prev-' + (i + 1)).on('click', function(e){
            //     e.preventDefault();
            //     alert('message?: DOMString');
            //     galleryBikeTop.swipePrev();
            // });
            // item.parent().find('.swiper-bike-child-next-' + (i + 1)).on('click', function(e){
            //     e.preventDefault();
            //     alert('message?: DOMString');
            //     galleryBikeTop.swipeNext();
            // });
        });
    }

    var VIDEO_PLAYING_STATE = {
        "PLAYING": "PLAYING",
        "PAUSE": "PAUSE"
    }

    var videoPlayStatus = VIDEO_PLAYING_STATE.PLAYING;


    window.addEventListener('resize', () => {
        
        if($(window).width()!=lastWidth){
            lastWidth = $(window).width();

            if(typeof galleryTopSwipers !== 'undefined'){
                galleryTopSwipers.map((s) => {
                    setTimeout(() => s.update(), 100);
                });            
            }

            if(typeof galleryBikeTopSwipers !== 'undefined'){
                galleryBikeTopSwipers.map((s) => {
                    setTimeout(() => s.update(), 100);
                });
            }
        }
    });

    function updateThumbsView(swiper) {
        const windowWidth = window.innerWidth;

        swiper.slides.map((s, i) => {
            const index = i+1;

            if ( windowWidth >= 992 && $('#gallery-thumbs-top-' + index).length ) {
                $('#thumbs-' + index).appendTo('#gallery-thumbs-top-' + index);
            } else if ( $('#gallery-thumbs-bottom-' + index).length ) {
                $('#thumbs-' + index).appendTo('#gallery-thumbs-bottom-' + index);
            }
        });

        // swiper.lazy.load();
    }

    var realIndex = 0;

    $(".swiper-container-h").each(function(index, element){
        var $this = $(this);
        $this.addClass("instance-" + index);
        $this.find(".swiper-button-prev").addClass("btn-prev-" + index);
        $this.find(".swiper-button-next").addClass("btn-next-" + index);

        const sliderTotalNumber = $(this).data('slider-total-number');
        const paginationType = 'fraction';
        const paginationTypeClass = '.swiper-pagination-h';
        const keyboardEnabled = ($(element).hasClass('bikeSwiper')) ? false : true;
        const allowTouchMove = ($(element).hasClass('bikeSwiper')) ? false : true;
        
        const config = {
            on: {

                'slideChange': function(s){                    
                    instance.update();                    
                },

                update:  function(s) {
                    $('.swiper-pagination-current').attr('data-content', '0');
                    
                    // pause all videos
                    s.slides.map((item, i) => {
                        const video = $(item).find('.video-gallery').first();
                        if (video && video.length) {
                            video.trigger('pause');
                        }
                    });

                    //play current slide video
                    const video = $(s.slides[s.activeIndex]).find('.video-gallery').first();
                    setTimeout(() => {
                        video.trigger('scroll');
                    }, 250)

                    if (video && video.length) {
                        video.trigger('play');
                    }
                },
            },
            spaceBetween: 15,
            nested: true,
            keyboard: {
                enabled: keyboardEnabled,
                onlyInViewport: keyboardEnabled,
            },
            loop: true,
            draggable: false,
            allowTouchMove: allowTouchMove,
            //loopedSlides: 10,
            pagination: {
                el: paginationTypeClass,
                clickable: true,
                type: paginationType,
            },
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            preloadImages: false,
            lazy: {
                checkInView: true
            },
            navigation: {
                nextEl: ".btn-next-" + index,
                prevEl: ".btn-prev-" + index,
            }
        };
        // if (index === 1) {
        //     config.preloadImages = false;
        //     config.lazy = true;
        // }


        const swiper = new Swiper(".instance-" + index, config);
        $('.swiper-slide-duplicate').html('');
            updateThumbsView(swiper);
            window.addEventListener('resize', () => {                
                if($(window).width()!=lastWidth){                    
                    lastWidth = $(window).width();
                    updateThumbsView(swiper);
                }
            });
        if (index === 0) {
        }

        swiper.on("afterInit", function(s) {
            alert('message?: DOMString');
        
        });

        swiper.on("slideChange", function(s) {

            if (s.activeIndex < 1) {
                s.slideTo(sliderTotalNumber);
            } else if (s.activeIndex > sliderTotalNumber) {
                s.slideTo(1);
            }

            realIndex = swiper.realIndex;

            // pause all videos
            s.slides.map((item, i) => {
                const video = $(item).find('.video-gallery').first();
                if (video && video.length) {
                    video.trigger('pause');
                }
            });

            //play current slide video
            const video = $(s.slides[s.activeIndex]).find('.video-gallery').first();
            setTimeout(() => {
                video.trigger('scroll');
            }, 250)

            if (video && video.length) {
                video.trigger('play');
            }
        });


        $('.swiper-pagination-current').attr('data-content', '0');     

        swiper.on('slideChange', function () {
            indexCreativity = swiper.activeIndex;
            let currentIndex = '0';
            if (indexCreativity < 1 || (indexCreativity > 9)) {
                currentIndex = '';
            }
            $('.swiper-pagination-current').eq(index).attr('data-content', currentIndex);
        });

    });


    //Generate image array for lightgallery-creativity
    var lightgalleryCreativityImages = [];

    $('.lightgallery-creativity').each((index, element) => {
        lightgalleryCreativityImages.push({ "src": $(element).find('.swiper-slide').data('src') });
    });

    $('.lightgallery-creativity').each((index, element) => {
        $(element).on('click', function() {
            $(this).lightGallery({
                galleryId: "lightgallery-"+index,
                dynamic: true,
                download: false,
                share: false,
                fullScreen: false,
                autoplayControls: false,
                thumbnail: false,
                index:  realIndex,
                dynamicEl: lightgalleryCreativityImages
            });
        });


    });
    
    if($('.nav-tabs-bike').length) {
        $('.nav-tabs-bike').on('click', 'a', function() {


        });
    }
 
    $('.nav-tabs-bike a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
        const mySwiper = $($(this).attr('href')).find('.bikeSwiper')[0].swiper;
        const mySwiperThumbs = $($(this).attr('href')).find('.gallery-new-thumbs-bike');
        const mySwiperGallery = $($(this).attr('href')).find('.gallery-top');

        const tabElem = $(this).attr('href');
        
        mySwiper.update();
        mySwiper.lazy.load();
        instance.update();
        
        updateThumbsView(mySwiper);

        mySwiperThumbs.each(function(index, el) {
           el.swiper.update();
        });

        mySwiperGallery.each(function(index, el) {
            el.swiper.update();
        });
    });

    $(window).scroll(function() {
        if ($(this).scrollTop() > 100) { // this refers to window
          $('.page-template-home-template .navbar').removeClass('homepage');
        } else {
            if($('.navbar > .container').hasClass('active')) {
                $('.page-template-home-template .navbar').removeClass('homepage');
            } else {
                $('.page-template-home-template .navbar').addClass('homepage');
            }
        }
    });

}(jQuery));
